import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../../shared/profile.service';
import { ProfileBenefitActivitySummary } from './profile-benefit-activity-summary.model';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-view-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.css'],
    standalone: false
})
export class ProfileViewBenefitsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public profileId: number;

  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;

  public benefitSummary: ProfileBenefitActivitySummary;

  public constructor(profileService: ProfileService, observationService: ObservationService, private router: Router) {
    this._profileService = profileService;
    this._observationService = observationService;

    this.benefitSummary = {} as ProfileBenefitActivitySummary;
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadData();
  }

  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData(true);
    }
  }

  public manageBenefits() {
    this.router.navigate([`benefits/profile/${this.profileId}`]);
  }

  private loadData(forceRefresh?: boolean) {
    this._profileService.getProfileViewBenefitsSummary(this.profileId, forceRefresh).then((data: ProfileBenefitActivitySummary) => {
      this.benefitSummary = data;
    });
  }
}
